class PhoneCaseRelease {
  constructor(section) {
    this.section = section;
    this.stage = section.querySelector('.phone-case-release__stage');
    this.startBlur = parseFloat(section.style.getPropertyValue('--pcr-blur')) || 26;
    this.scrollStart = 0;
    this.scrollDistance = 1;
    this.ticking = false;

    this.update = this.update.bind(this);
    this.requestUpdate = this.requestUpdate.bind(this);
    this.measure = this.measure.bind(this);

    window.addEventListener('scroll', this.requestUpdate, { passive: true });
    window.addEventListener('resize', this.measure);
    window.addEventListener('orientationchange', this.measure);
    this.measure();
  }

  measure() {
    const stageRect = this.stage.getBoundingClientRect();
    const pageY = window.scrollY || window.pageYOffset || 0;

    this.scrollStart = stageRect.top + pageY;
    this.scrollDistance = Math.max(1, this.stage.offsetHeight - window.innerHeight);
    this.requestUpdate();
  }

  requestUpdate() {
    if (this.ticking) return;

    this.ticking = true;
    window.requestAnimationFrame(this.update);
  }

  update() {
    const pageY = window.scrollY || window.pageYOffset || 0;
    const rawProgress = (pageY - this.scrollStart) / this.scrollDistance;
    const progress = Math.min(1, Math.max(0, rawProgress));
    const eased = Math.pow(progress, 1.35);
    const blur = Math.max(0, this.startBlur * (1 - eased));
    const mistOpacity = Math.max(0, 0.82 * (1 - eased));
    const scale = 0.92 + eased * 0.08;
    const contentY = eased * -2.4;
    const mistX = (1 - eased) * -4;
    const mediaY = (1 - eased) * 2.4;
    const haloOpacity = 0.24 + eased * 0.5;
    const haloScale = 0.82 + eased * 0.18;
    const shadowOpacity = 0.22 + eased * 0.2;
    const mediaOpacity = 0.72 + eased * 0.28;
    const mediaSaturate = 0.78 + eased * 0.24;
    const mediaContrast = 0.88 + eased * 0.16;

    this.section.style.setProperty('--pcr-progress', eased.toFixed(3));
    this.section.style.setProperty('--pcr-blur', `${blur.toFixed(2)}px`);
    this.section.style.setProperty('--pcr-glass-opacity', mistOpacity.toFixed(3));
    this.section.style.setProperty('--pcr-product-scale', scale.toFixed(3));
    this.section.style.setProperty('--pcr-content-y', `${contentY.toFixed(2)}rem`);
    this.section.style.setProperty('--pcr-mist-x', `${mistX.toFixed(2)}rem`);
    this.section.style.setProperty('--pcr-media-y', `${mediaY.toFixed(2)}rem`);
    this.section.style.setProperty('--pcr-halo-opacity', haloOpacity.toFixed(3));
    this.section.style.setProperty('--pcr-halo-scale', haloScale.toFixed(3));
    this.section.style.setProperty('--pcr-shadow-opacity', shadowOpacity.toFixed(3));
    this.section.style.setProperty('--pcr-media-opacity', mediaOpacity.toFixed(3));
    this.section.style.setProperty('--pcr-media-saturate', mediaSaturate.toFixed(3));
    this.section.style.setProperty('--pcr-media-contrast', mediaContrast.toFixed(3));
    this.ticking = false;
  }
}

function initPhoneCaseRelease(root = document) {
  root.querySelectorAll('[data-phone-case-release]').forEach((section) => {
    if (section.phoneCaseRelease) return;

    section.phoneCaseRelease = new PhoneCaseRelease(section);
  });
}

initPhoneCaseRelease();

document.addEventListener('shopify:section:load', (event) => {
  initPhoneCaseRelease(event.target);
});
